module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/google.33809905.svg";